<template>
  <div class="holdings-section" v-if="holdingsOnCompletion?.length">
    <h2>{{ t('simulation.holdings.title') }}</h2>
    <div class="table-container">
      <table class="holdings-table">
        <thead>
          <tr>
            <th>{{ t('simulation.holdings.headers.asset') }}</th>
            <th>{{ t('simulation.holdings.headers.quantity') }}</th>
            <th>{{ t('simulation.holdings.headers.averageCost') }}</th>
            <th>{{ t('simulation.holdings.headers.currentPrice') }}</th>
            <th>{{ t('simulation.holdings.headers.unrealizedPnL') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(holding, index) in holdingsOnCompletion" :key="index">
            <td>{{ holding.asset_name || holding.asset_code }}</td>
            <td>{{ formatPosition(holding.quantity) }}</td>
            <td>{{ formatNumber(holding.average_cost_price) }}</td>
            <td>{{ formatNumber(holding.current_market_price) }}</td>
            <td :class="getProfitClass(holding.price_difference)">
              {{ formatNumber(holding.price_difference) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  holdingsOnCompletion: {
    type: Array,
    default: () => []
  }
});

const { t } = useI18n()

const formatNumber = (value) => {
  if (value == null) return t('common.notAvailable')
  return typeof value === 'number' ? value.toFixed(2) : value;
};

const getProfitClass = (value) => {
  if (value == null || value === 0) return 'neutral';
  return value > 0 ? 'positive' : 'negative';
};

const formatPosition = (quantity) => {
  if (quantity == null) {
    return t('common.notAvailable')
  }
  if (quantity === 0) {
    return t('simulation.holdings.position.flat')
  }
  const absQuantity = Math.abs(quantity)
  return quantity > 0
    ? t('simulation.holdings.position.long', { quantity: absQuantity })
    : t('simulation.holdings.position.short', { quantity: absQuantity })
};
</script>

<style scoped>
.holdings-section {
  margin-bottom: 32px;
}

.holdings-section h2 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #262626;
}

.table-container {
  overflow-x: auto;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.holdings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.holdings-table th,
.holdings-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
}

.holdings-table th {
  background: #fafafa;
  font-weight: 600;
  color: #262626;
}

.holdings-table tr:last-child td {
  border-bottom: none;
}

.positive { color: #52c41a; }
.negative { color: #ff4d4f; }
.neutral { color: #8c8c8c; }
</style>
